import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Card, message, Switch } from "antd";
import { useQuery } from "@apollo/client";
import CustomTable from "../../../../../../components/CustomDataTable";
import {
  LIST_TIERED_CUSTOMERS,
  LIST_LOYALTY_CUSTOMERS,
  LIST_LOYALTIES,
  GET_ALL_CUSTOMERS,
  GET_MULTITIER_TRASACTIONS
} from "../Loyalties/constants";
import MemberDetailModal from "./_partials/MemberDetailModal";
import strings from "../../../../../../strings";
import moment from "moment";
import MtierTransactionDetails from "./MtierTransactionDetails";

const Members = ({ user, showFullInfo }) => {
  const [customerData, setCustomerData] = useState([]);
  const [currentMember, setCurrentMember] = useState(null);
  const [activeLoyaltyId, setActiveLoyaltyId] = useState(null);
  const [ showCustDetails, setShowCustDetails ] = useState(false);
  const [showAllCustomers, setSowAllCustomers ] = useState([]);
  const [ transactionHistory, setTransactionHistory ] = useState([]);
  const [ openTransactionModal, setOpenTransactionModal ] = useState(false);
  const [ selectedTransaction, setSelectedTransaction ] = useState(null);

  const [isViewMemberModalOpen, setIsViewMemberModalOpen] = useState(false);

  const { loading: isCustomerLoading, data } = useQuery(LIST_TIERED_CUSTOMERS, {
    onError: (error) => {
      message.error(error.message, 5);
    },
    fetchPolicy: "network-only",
  });

  // const { loading: isAllCustomersLoading } = useQuery(GET_ALL_CUSTOMERS, {
  //   onError: (error) => {
  //     message.error(error.message, 5);
  //   },onCompleted: (data) => {
  //     console.log("data", data);
  //     setSowAllCustomers(data.customer);
  //   }
  // });

  const { loading: isAllTransactionLoading } = useQuery(GET_MULTITIER_TRASACTIONS, {
    variables: {
      merchant_id: user.employer ? user.employer.id : user.id
    },
    onError: (error) => {
      message.error(error.message, 5);
    },
    onCompleted: (data) => {
      setTransactionHistory(data.getMultitierTransactions);
    }
  });
  

  const { data: result } = useQuery(LIST_LOYALTIES, {
    onError: (error) => {
      message.error(error.message, 5);
    },
    fetchPolicy: "network-only",
  });
  const { data: loyaltyData } = useQuery(LIST_LOYALTY_CUSTOMERS, {
    variables: { loyalty_id: activeLoyaltyId },
    onError: (error) => {
      message.error(error.message, 5);
    },
    fetchPolicy: "network-only",
    skip: !activeLoyaltyId,
  });

  useEffect(() => {
    const multiLevelLoyalties = result
      ? result.listLoyalties
        ? result.listLoyalties
        : []
      : [];
    const activeLoyalty =
      multiLevelLoyalties.length > 0 &&
      multiLevelLoyalties.find(
        (loyalty) => loyalty.status.toLowerCase() === "active"
      );
    if(activeLoyalty && activeLoyalty.owner_id){
      if (user.id !== activeLoyalty.owner_id) {
        setActiveLoyaltyId(activeLoyalty.id);
      }
    }
  }, [result, user.id]);

  useEffect(() => {
    if (data) {
      const customerData = data.listTieredCustomers.map((customer, idx) => {
        return {
          ...customer,
          key: customer ? customer.id : idx,
        };
      });
      setCustomerData(customerData);

      if (loyaltyData) {
        const loyaltyCustomers = loyaltyData.listLoyaltyCustomers.map(
          (customer, idx) => {
            return { ...customer, key: customer ? customer.id : idx };
          }
        );
        setCustomerData(loyaltyCustomers);
      }
    }
  }, [data, loyaltyData]);

  useEffect(() => {
    
  }, [loyaltyData])

  const toggleViewMemberModal = () => setIsViewMemberModalOpen((open) => !open);

  const handleCalculatePoint = (amount) => {
    const activeLoyalty = result && result.listLoyalties.find(loyalty => loyalty.status === "Active");

    if(activeLoyalty) {
      const points = activeLoyalty.points;
      const currencyValue = activeLoyalty.currency_value;
      const pointSpent = (Number(amount) * Number(points)) / Number(currencyValue);

      return pointSpent.toFixed(2);
      
    }
  }

  const columns = [
    {
      title: strings.firstName,
      dataIndex: "first_name",
      key: "first_name",
      render: (data) => data || "N/A",
    },
    {
      title: strings.lastName,
      dataIndex: "last_name",
      key: "last_name",
      render: (data) => data || "N/A",
    },
    {
      title: strings.email,
      dataIndex: "email",
      key: "email",
      render: (data) => data || "N/A",
    },
  ];

  const columnsCustomer = [
    {
      title: strings.firstName,
      dataIndex: "customer",
      key: "first_name",
      render: (data) => <span>{JSON.parse(data).first_name}</span> || "N/A",
    },
    {
      title: strings.lastName,
      dataIndex: "customer",
      key: "last_name",
      render: (data) => JSON.parse(data).last_name || "N/A",
    },
    {
      title: strings.email,
      dataIndex: "customer",
      key: "email",
      render: (data) => JSON.parse(data).email || "N/A",
    },
    {
      title: strings.transactionType,
      dataIndex: "transaction_type",
      key: "transaction_type",
      render: (data) => <span>{data}</span> || "N/A",
    },
    {
      title: strings.mtierAmount,
      dataIndex: "mtier_amount",
      key: "mtier_amount",
      render: (data) => <span>{data}</span> || "N/A",
    },
     {
      title: strings.pointUsed,
      dataIndex: "mtier_amount",
      key: "mtier_amount",
      render: (data) => <span>{handleCalculatePoint(data) || "N/A"}</span> || "N/A",
    },
    {
      title: strings.tier,
      dataIndex: "tier",
      key: "tier",
      render: (data) => {
        return data && JSON.parse(data).length> 0 && <p>{JSON.parse(data)[0].name}</p> || "N/A"
      },
    },
    {
      title: strings.createdDate,
      dataIndex: "transaction_date",
      render: (record) => (record ? <span>{moment(record).format("YYYY-MM-DD")}</span> : <span>N/A</span>),
      sorter: (a, b) => {
        return moment(a.createdDate) < moment(b.createdDate);
      },
    },
    {
      title: strings.createdTime,
      dataIndex: "transaction_date",
      render: (record, value) => (record ? <span>{moment(record).format("h:mm:ss A")}</span> : <span>N/A</span>),
    },
    {
      title: strings.servedBy,
      dataIndex: "staff",
      key: "staff",
      render: (data) => <span>{data && JSON.parse(data).username || "Admin"}</span> || "Admin",
    },
  ];

  return (
    <section className="apps-multilevel-members">
      <Card 
        title={showFullInfo ? "Multi-tier Transactions" : `${strings.allEnrolledMembers} (${customerData.length})`}
        // extra={(
        //   <div style={{display: "flex", alignItems: "center", gap: 10}}>
        //     <p style={{margin: 0}}>View Customer Points</p>
        //     <Switch onChange={(value) => setShowCustDetails(value)} checked={showCustDetails}  />
        //   </div>
        // )}
      >
        <CustomTable
          loading={showFullInfo ? isAllTransactionLoading : isCustomerLoading}
          columns={showFullInfo ? columnsCustomer : columns}
          dataSource={showFullInfo ? transactionHistory :customerData}
          currentMember={currentMember}
          onRow={(record) => {
            return {
              onClick: () => {
                setCurrentMember(record);
                if(showFullInfo) {
                  setSelectedTransaction(record);
                  setOpenTransactionModal(true);
                }else{
                  toggleViewMemberModal();
                }
              },
            };
          }}
        />
      </Card>

      {isViewMemberModalOpen ? (
        <MemberDetailModal
          visible={isViewMemberModalOpen}
          closeModal={toggleViewMemberModal}
          currentMember={currentMember}
        />
      ) : null}

      {openTransactionModal && (
        <MtierTransactionDetails 
          open={openTransactionModal}
          onCancel={() => setOpenTransactionModal(false)}
          transactionDetails={selectedTransaction}
          result={result}
          user={user}
        />
      )}
    </section>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

export default connect(mapStateToProps, null)(Members);
